export default "__VITE_ASSET__b4ffba81__"